// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import React from 'react';
export class ImageContextMenuItem extends React.Component {
    constructor() {
        super(...arguments);
        this.ref = React.createRef();
        this.onClick = () => {
            const item = this.props.item;
            if (!isNullOrUndefined(item.event)) {
                item.event(item);
            }
            this.props.onCloseContextMenu();
        };
        this.onPointerEnter = () => {
            if (isValidString(this.props.item.tooltip)) {
                showTooltip(this.ref.current, Resources.getResource(this.props.item.tooltip));
            }
        };
        this.onPointerLeave = () => {
            if (isValidString(this.props.item.tooltip)) {
                hideTooltip();
            }
        };
    }
    render() {
        const activeStyle = this.props.item.selected ? ' _active' : '';
        const disabledStyle = this.props.item.enabled === false ? ' _disabled' : '';
        return (React.createElement("div", { className: `new-context-menu-row${activeStyle}${disabledStyle}`, ref: this.ref, onClick: this.onClick, onPointerEnter: this.onPointerEnter, onPointerLeave: this.onPointerLeave },
            React.createElement("div", { className: "new-context-menu-item" },
                React.createElement("div", { className: "new-context-menu-item-image" },
                    React.createElement("svg", null,
                        React.createElement("use", { xlinkHref: `assets/webdesktop/web-desktop-sprite.svg#${this.props.item.svgImage}` }))))));
    }
}
